import React from 'react';
import useCartMessages from '../../hooks/useCartMessages';
import './CartMessages.css';

export default function CartMessages({ refreshKey, ...context }) {
  const messages = useCartMessages(context, refreshKey);
  return (
    <div className="cart-messages" aria-live="polite" aria-atomic="true">
      {messages.map(message => (
        <div key={message.id} className={`cart-message cart-message--${message.tone}`} role="status">
          <span className="cart-message__icon" aria-hidden="true">
            {message.tone === 'success' ? '✓' : '!'}</span>
          <div className="cart-message__content">
            <strong className="cart-message__title">Delivery update</strong>
            <span className="cart-message__text">{message.text}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
